import { __ } from '@wordpress/i18n';
import React, { useState, useEffect, Component } from 'react';
import {
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Switch,
    TextField,
    FormControl,
    Select,
    MenuItem,
    InputLabel
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MyCredPaymentGateway from './components/MyCredPaymentGateway';

const ReactComponent = ({ title, content, state, setState }) => {
    const [toggleChecked, setToggleChecked] = useState(false);
    const [pointsOptions, setPointsOptions] = useState([]);
    const [selectedPointType, setSelectedPointType] = useState('');
    

    useEffect(() => {

        const savedPaymentGateways = localStorage.getItem('paymentGateways');
        if (savedPaymentGateways) {
            setState(JSON.parse(savedPaymentGateways));
        }

        const savedToggleState = localStorage.getItem('toggleState');
        if (savedToggleState !== null) {
            setToggleChecked(JSON.parse(savedToggleState));
        }


        if (window.points_data && Object.keys(window.points_data).length > 0) {
            const options = Object.entries(window.points_data).map(([key, value]) => ({
                id: key,
                label: value.label || key
            }));
            setPointsOptions(options);
            if (options.length > 0 && options[0].id) {
                setSelectedPointType(options[0].id);
            }
        }


        setState(prevState => ({
            paymentGateways: {
                ...prevState.paymentGateways,
                mycred: {
                    toggled: true,
                    ...prevState.paymentGateways.mycred
                }
            }
        }));
    }, []);

    useEffect(() => {

        localStorage.setItem('toggleState', JSON.stringify(toggleChecked));
    }, [toggleChecked]);

    const handleToggleChange = (event) => {
        setToggleChecked(event.target.checked);
    };

    const handleInputChange = (key, value) => {
        setState(prevState => {
            const newState = {
                paymentGateways: {
                    ...prevState.paymentGateways,
                    mycred: {
                        ...prevState.paymentGateways.mycred,
                        [key]: value
                    }
                }
            };

            localStorage.setItem('paymentGateways', JSON.stringify(newState));
            return newState;
        });
    };

    return (
        <div className="wphook-react" style={{ paddingTop: '32px', paddingLeft: '32px' }}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#ffffff" }} />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                        bgcolor: "#036666",
                        borderRadius: "5px",
                        padding: '0 16px',
                    }}
                >
                    <Typography sx={{ color: "#ffffff" }}>
                        {title}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography sx={{ padding: '20px' }}>
                        {content}
                        <Switch
                            checked={toggleChecked}
                            onChange={handleToggleChange}
                            color="primary"
                            inputProps={{ 'aria-label': 'Toggle switch' }}
                        />
                        <span> myCred Gateway</span>
                        {toggleChecked && (
                            <Grid container spacing={2} sx={{ marginTop: '16px' }}>
                                {[
                                    { label: 'Title', key: 'title' },
                                    { label: 'Description', key: 'description' },
                                    { label: 'Log Template', key: 'log' },
                                    { label: 'Exchange Rate', key: 'exchangerate' },
                                    { label: 'Order Total in Points', key: 'ordertotal' },
                                    { label: 'Balance Label', key: 'balancelabel' },
                                    { label: 'Profit Sharing', key: 'profitsharing' },
                                ].map(({ label, key }) => (
                                    <Grid item xs={12} key={key}>
                                        <FormControl fullWidth>
                                            <TextField
                                                label={label}
                                                value={state.paymentGateways.mycred[key] || ''}
                                                onChange={(e) => handleInputChange(key, e.target.value)}
                                                variant="outlined"
                                                placeholder={`Enter ${label}`}
                                                inputProps={{ "data-key": key }}
                                            />
                                        </FormControl>
                                    </Grid>
                                ))}
                                <Grid item xs={12}>
                                    <FormControl fullWidth sx={{ marginTop: '16px' }}>
                                        <InputLabel id="point-type-select-label">Select Point Type</InputLabel>
                                        <Select
                                            labelId="point-type-select-label"
                                            id="point-type-select"
                                            value={state.paymentGateways.mycred.pointtypechange || ''}
                                            label="Select Point Type"
                                            onChange={(e) => handleInputChange('pointtypechange', e.target.value)}
                                            inputProps={{ "data-key": "pointType" }}
                                            variant="outlined"
                                        >
                                            {pointsOptions.length > 0 ? (
                                                pointsOptions.map((option) => (
                                                    <MenuItem key={option.id} value={option.id}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem value="">
                                                    No options available
                                                </MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12}>
                                    <FormControl fullWidth sx={{ marginTop: '16px' }}>
                                        <InputLabel id="gateway-mycred-show-total-label">Show Total</InputLabel>
                                        <Select
                                            labelId="gateway-mycred-show-total-label"
                                            id="gateway_mycred_show_total"
                                            value={state.paymentGateways.mycred.showtotal || ''}
                                            onChange={(e) => handleInputChange('showtotal', e.target.value)}
                                            label="Show Total"
                                            variant="outlined"
                                            inputProps={{ "data-key": "showTotal" }}
                                        >
                                            <MenuItem value="hide">Do Not Show</MenuItem>
                                            <MenuItem value="checkout">Checkout</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        )}
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

wp.hooks.addFilter(
    'bookify_add_payment_settings',
    'mycred-bookify',
    function (content, state, setState) {
        if (!content.find(item => item.key === 'mycred-payment-settings')) {
            content.push(
                <ReactComponent
                    key="mycred-payment-settings"
                    title="Payment with myCred"
                    content=""
                    state={state}
                    setState={setState}
                />
            );
        }
        return content;
    },
    10
);

wp.hooks.addFilter(
    'bookify_save_payment_settings_validation',
    'mycred-bookify',
    function (errors, paymentGateways) {
        if (!errors) {
            errors = [];
        }

        if (!paymentGateways.mycred.pointtypechange) {
            errors.push({
                field: 'pointtypechange',
                message: 'Point Type is required.',
            });
        }

        const validPointTypes = Object.keys(window.points_data);

        if (paymentGateways.mycred.pointtypechange && !validPointTypes.includes(paymentGateways.mycred.pointtypechange)) {
            errors.push({
                field: 'pointtypechange',
                message: 'Selected Point Type is invalid.',
            });
        }

        return errors;
    },
    10
);


wp.hooks.addFilter(
    'bookify_add_payment_gateway',
    'mycred-bookify',
    function (
        gatewaySettings, 
        parsedSetting, 
        currencyCode, 
        handleMethodChange, 
        submitBooking, 
        state, 
        updateInput, 
        localState, 
        setLocalState
    ) {
       
        const validGatewaySettings = Array.isArray(gatewaySettings) ? gatewaySettings : [];

        const myCredGateway = {
            key: 'mycred_gateway',
            title: window.mycredBookify.payment_settings_data.mycred?.title || 'myCred Gateway',
            isEnabled: window.mycredBookify.payment_settings_data.mycred?.toggled || false,
            description: window.mycredBookify.payment_settings_data.mycred?.description,
            ordertotal: window.mycredBookify.payment_settings_data.mycred?.ordertotal,
            balancelabel: window.mycredBookify.payment_settings_data.mycred?.balancelabel,
            balance: window.mycredBookify.balance,
            showtotal: window.mycredBookify.payment_settings_data.mycred?.showtotal,
            onChange: handleMethodChange,
            onSubmit: submitBooking,
            additionalState: state,
            updateInput,
            localState,
            setLocalState
        };

        const updatedGatewaySettings = [...validGatewaySettings, myCredGateway];

        return (
            <>
                {updatedGatewaySettings.map((gateway) => 
                    gateway.key === 'mycred_gateway' && gateway.isEnabled ? (
                        <MyCredPaymentGateway
                            key={gateway.key}
                            title={gateway.title}
                            description={gateway.description}
                            handleGatewayChange={gateway.onChange}
                            submitBooking={gateway.onSubmit}
                            ordertotal={gateway.ordertotal}
                            balancelabel={gateway.balancelabel}
                            balance={gateway.balance}
                            showtotal={gateway.showtotal}
                            state={state} 
                            setState={setLocalState} 
                        />
                    ) : null
                )}
            </>
        );
    },
    10
);


export default ReactComponent;
